import { WebCamUI } from 'vue-camera-lib';
export default WebCamUI;
